var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "450px",
        persistent: "",
        color: "background",
        transition: "dialog-bottom-transition"
      },
      model: {
        value: _vm.showDialog,
        callback: function($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "", dark: "", dense: "", color: "primary" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  on: { click: _vm.fecharModal }
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
              _c("v-toolbar-title", { staticClass: "pa-0" }, [
                _vm._v(" " + _vm._s(_vm.tituloModal) + " ")
              ])
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticClass: "py-5 px-6 text-justify content-style" },
            [_c("span", { domProps: { innerHTML: _vm._s(_vm.textoModal) } })]
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "justify-end" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "success", "data-cy": "confirmacaoModal" },
                  on: { click: _vm.confirmar }
                },
                [_vm._v(" " + _vm._s(_vm.btnConfirmar) + " ")]
              ),
              !_vm.esconderCancelar
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ml-4",
                      attrs: { "data-cy": "fecharConfirmacaoModal" },
                      on: { click: _vm.fecharModal }
                    },
                    [_vm._v(" " + _vm._s(_vm.btnCancelar) + " ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }